module.exports = __webpack_public_path__ + "img/icon-appstore.426e7696.png";